import { defineMessages } from 'react-intl';

export const estimationCancelReviewButtonMessageDefinitions = defineMessages({
  cancelReviewButton: {
    id: 'estimationDetail.cancelReviewButton',
    defaultMessage: 'Cancel Review',
  },
});
